module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-01-ddbb375b008267ca488b3938d373201b.jpg";